<template>
  <div
    :style="{ padding: !reply ? '10px 10px 10px 10px' : '10px 0 10px 10px' }"
  >
    <div style="background: var(--primary-background-third); padding: 20px">
      <v-chip
        v-if="comment.inPoint"
        class="cursor-pointer mr-5"
        text-color="white"
        style="
          height: 25px;
          font-size: 10px;
          border: 1px solid var(--primary);
          border-radius: 15px !important;
        "
        @click="jumpToCallback(comment.inPoint)"
        color="var(--primary)"
      >
        <v-avatar left> IN </v-avatar>
        <span>{{ comment.inPoint }}</span>
      </v-chip>
      <v-chip
        v-if="comment.outPoint"
        class="cursor-pointer"
        text-color="white"
        style="
          height: 25px;
          font-size: 10px;
          border: 1px solid var(--attention);
          border-radius: 15px !important;
        "
        @click="jumpToCallback(comment.outPoint)"
        color="var(--attention)"
      >
        <v-avatar left> OUT </v-avatar>
        <span>{{ comment.outPoint }}</span>
      </v-chip>

      <p style="white-space: pre-line" class="ml-3 mt-3">
        {{ comment.comment }}
      </p>
      <v-row>
        <v-col class="pb-0" cols="7">
          <h4 v-if="comment.edited">
            <v-icon small class="mr-1" v-if="reply">reply</v-icon
            >{{ comment.email }} - <br />
            {{ comment.createDate | formatDateTime }}
            - (edited)
          </h4>
          <h4 v-else>
            <v-icon small class="mr-1" v-if="reply">reply</v-icon
            >{{ comment.email }} - <br />{{
              comment.createDate | formatDateTime
            }}
          </h4>
        </v-col>
        <v-col v-if="$checkAccess(job, 'COMMENT')" class="pb-0" cols="5">
          <p class="text-right" v-if="!reply">
            <span
              v-if="comment.email === $store.getters.getUser.email"
              @click="editCallback(comment)"
              class="cursor-pointer mr-3"
              ><v-icon small class="mr-1" color="primary">edit</v-icon
              >{{$t('views.detailView.edit')}}</span
            >
            <span @click="replyCallback(comment.id)" class="cursor-pointer"
              ><v-icon small class="mr-1" color="primary">reply</v-icon>
              {{$t('views.detailView.reply')}}</span
            >
          </p>
          <p class="text-right" v-else>
            <span
              v-if="comment.email === $store.getters.getUser.email"
              @click="editCallback(comment)"
              class="cursor-pointer mr-3"
              ><v-icon small class="mr-1" color="primary">edit</v-icon
              >{{$t('views.detailView.edit')}}</span
            >
          </p>
        </v-col>
      </v-row>
    </div>
    <div
      v-for="cmt in comment.replies"
      :key="cmt.id"
      style="border-top: 2px solid var(--primary-background) !important"
    >
      <Comment
        class="pl-12"
        :reply="true"
        :comment="cmt"
        :editCallback="editReply"
        :jumpToCallback="jumpToCallback"
        :key="cmt.id"
      />
    </div>
  </div>
</template>

<script>
import AccessChecker from "@/mixins/AccessChecker";

export default {
  name: "Comment",

  data: () => {
    return {};
  },

  mixins: [AccessChecker],

  methods: {
    editReply(comment) {
      this.$props.editCallback(comment);
    },
  },

  props: {
    jumpToCallback: {
      type: Function,
      default: () => {},
    },
    editCallback: {
      type: Function,
      default: () => {},
    },
    replyCallback: {
      type: Function,
      default: () => {},
    },
    reply: {
      type: Boolean,
      defaut: false,
    },
    comment: {
      type: Object,
      default: () => {},
    },
    job: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped></style>
